import { useEffect } from 'react';

export default function useBodyClassToggle(className: string, enabled: boolean) {
  useEffect(() => {
    const body = typeof document !== 'undefined' ? document.body : null;
    if (!body) return;

    if (enabled) body.classList.add(className);
    else body.classList.remove(className);

    return () => {
      body.classList.remove(className);
    };
  }, [className, enabled]);
}
